export default {
  namespaced: true,
  state: {
    bannersList: [],
    group: null,
  },
  actions: {
    GetBannersList({ commit, rootGetters, dispatch }, profileID) {
      return new Promise((resolve, reject) => {
        rootGetters.ax.post('/banners/api/banners/index', { group: 'guest-index', profile_id: profileID })
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'bannersList', value: response.data.banners });
              commit('setField', { name: 'group', value: response.data.group });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    InitialStoreBanners({ commit }) {
      commit('setField', { name: 'bannersList', value: [] });
      commit('setField', { name: 'group', value: [] });
    },
  },
  mutations: {
    setField(state, payload) {
      state[payload.name] = payload.value;
    },
  },
};
